package com.applaunchkit.website.style

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.selection

val TextSelectionStyle = CssStyle {
    base {
        Modifier
    }
    selection {
        Modifier
            .backgroundColor(Colors.White)
            .color(Colors.Black)
    }
}